/**
 * DeSight Shopify X | v1.0.0
 * Ankündigungen Pop-Up Component
 *
 * Enterprise-Level Ankündigungen Pop-Up mit Cookie-Steuerung und intelligenten Triggern
 */

(function () {
  'use strict';

  /**
   * Cookie Helper Functions
   */
  const CookieManager = {
    set: function (name, value, days) {
      const expires = new Date();
      expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
      document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
    },

    get: function (name) {
      const nameEQ = name + '=';
      const ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    },

    delete: function (name) {
      this.set(name, '', -1);
    }
  };

  /**
   * Marketing Pop-Up Manager
   */
  function initMarketingPopup() {
    const popup = document.getElementById('desight-marketing-popup');

    if (!popup) {
      return;
    }

    // Get settings from data attributes
    const trigger = popup.getAttribute('data-trigger') || 'delay';
    const delay = parseInt(popup.getAttribute('data-delay')) || 3;
    const scrollPercentage = parseInt(popup.getAttribute('data-scroll-percentage')) || 50;
    const useCookie = popup.getAttribute('data-use-cookie') === 'true';
    const cookieDays = parseInt(popup.getAttribute('data-cookie-days')) || 7;
    const closeOnOverlay = popup.getAttribute('data-close-on-overlay') === 'true';

    // Zeitsteuerung (Europa/Vienna)
    const scheduleEnabled = popup.getAttribute('data-schedule-enabled') === 'true';
    const scheduleStart = popup.getAttribute('data-schedule-start');
    const scheduleEnd = popup.getAttribute('data-schedule-end');
    const scheduleTimezone = popup.getAttribute('data-schedule-timezone') || 'Europe/Vienna';

    const cookieName = 'desight_popup_shown';
    let isShown = false;
    let exitIntentTriggered = false;

    /**
     * Parse German date format (dd.mm.YYYY HH:MM) to Date object
     * @param {string} dateStr - Date string in format "dd.mm.YYYY HH:MM" or "dd.mm.YYYY"
     * @returns {Date|null} - Parsed date or null if invalid
     */
    function parseGermanDate(dateStr) {
      if (!dateStr || dateStr.trim() === '') {
        return null;
      }

      // Format: dd.mm.YYYY HH:MM oder dd.mm.YYYY
      const parts = dateStr.trim().split(' ');
      const datePart = parts[0]; // dd.mm.YYYY
      const timePart = parts[1] || '00:00'; // HH:MM (default: 00:00)

      const dateComponents = datePart.split('.');
      if (dateComponents.length !== 3) {
        return null;
      }

      const day = parseInt(dateComponents[0], 10);
      const month = parseInt(dateComponents[1], 10) - 1; // Monate sind 0-basiert
      const year = parseInt(dateComponents[2], 10);

      const timeComponents = timePart.split(':');
      const hours = parseInt(timeComponents[0], 10) || 0;
      const minutes = parseInt(timeComponents[1], 10) || 0;

      // Erstelle Date-Objekt (lokale Zeit wird als Vienna interpretiert)
      const date = new Date(year, month, day, hours, minutes, 0);

      if (isNaN(date.getTime())) {
        return null;
      }

      return date;
    }

    /**
     * Check if popup is within scheduled time range (Europa/Vienna)
     */
    function isWithinSchedule() {
      if (!scheduleEnabled) {
        return true;
      }

      // Aktuelles Datum in Europa/Vienna Zeitzone
      const now = new Date();
      const viennaDate = new Date(now.toLocaleString('en-US', { timeZone: scheduleTimezone }));

      // Startdatum prüfen
      if (scheduleStart && scheduleStart.trim() !== '') {
        const startDate = parseGermanDate(scheduleStart);
        if (startDate && viennaDate < startDate) {
          return false;
        }
      }

      // Enddatum prüfen
      if (scheduleEnd && scheduleEnd.trim() !== '') {
        const endDate = parseGermanDate(scheduleEnd);
        if (endDate && viennaDate > endDate) {
          return false;
        }
      }

      return true;
    }

    /**
     * Check if popup should be shown based on cookie and schedule
     */
    function shouldShowPopup() {
      // Zeitsteuerung prüfen
      if (!isWithinSchedule()) {
        return false;
      }

      // Cookie prüfen
      if (!useCookie) {
        return true;
      }

      const cookieValue = CookieManager.get(cookieName);
      return cookieValue === null;
    }

    /**
     * Show the popup
     */
    function showPopup() {
      if (isShown || !shouldShowPopup()) {
        return;
      }

      popup.style.display = 'block';

      // Trigger reflow for animation
      popup.offsetHeight;

      popup.classList.add('desight-popup--visible');
      document.body.style.overflow = 'hidden';
      isShown = true;

      // Set cookie if enabled
      if (useCookie) {
        CookieManager.set(cookieName, 'true', cookieDays);
      }

      // Track event (if analytics available)
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'popup_shown',
          'popup_trigger': trigger
        });
      }
    }

    /**
     * Hide the popup
     */
    function hidePopup() {
      popup.classList.remove('desight-popup--visible');
      document.body.style.overflow = '';

      setTimeout(function () {
        popup.style.display = 'none';
      }, 300);

      // Track event (if analytics available)
      if (window.dataLayer) {
        window.dataLayer.push({
          'event': 'popup_closed'
        });
      }
    }

    /**
     * Trigger: Immediate
     */
    function triggerImmediate() {
      showPopup();
    }

    /**
     * Trigger: Delay
     */
    function triggerDelay() {
      setTimeout(function () {
        showPopup();
      }, delay * 1000);
    }

    /**
     * Trigger: Scroll
     */
    function triggerScroll() {
      let scrollTriggered = false;

      function checkScroll() {
        if (scrollTriggered) {
          return;
        }

        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const docHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;

        if (scrollPercent >= scrollPercentage) {
          scrollTriggered = true;
          showPopup();
          window.removeEventListener('scroll', checkScroll);
        }
      }

      window.addEventListener('scroll', checkScroll);
    }

    /**
     * Trigger: Exit Intent
     */
    function triggerExitIntent() {
      function handleMouseLeave(e) {
        if (exitIntentTriggered) {
          return;
        }

        // Check if mouse is leaving from top of viewport
        if (e.clientY <= 0) {
          exitIntentTriggered = true;
          showPopup();
          document.removeEventListener('mouseleave', handleMouseLeave);
        }
      }

      document.addEventListener('mouseleave', handleMouseLeave);
    }

    /**
     * Initialize trigger based on settings
     */
    function initTrigger() {
      switch (trigger) {
        case 'immediate':
          triggerImmediate();
          break;
        case 'delay':
          triggerDelay();
          break;
        case 'scroll':
          triggerScroll();
          break;
        case 'exit':
          triggerExitIntent();
          break;
        default:
          triggerDelay();
      }
    }

    /**
     * Event Listeners
     */

    // Close button
    const closeButton = popup.querySelector('.desight-popup__close');
    if (closeButton) {
      closeButton.addEventListener('click', hidePopup);
    }

    // Overlay click
    if (closeOnOverlay) {
      const overlay = popup.querySelector('.desight-popup__overlay');
      if (overlay) {
        overlay.addEventListener('click', hidePopup);
      }
    }

    // ESC key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isShown) {
        hidePopup();
      }
    });

    // Newsletter form submission
    const newsletterForm = popup.querySelector('.desight-popup__newsletter-form');
    if (newsletterForm) {
      newsletterForm.addEventListener('submit', function () {
        // Track event (if analytics available)
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'newsletter_signup',
            'source': 'popup'
          });
        }

        // Close popup after short delay
        setTimeout(hidePopup, 1500);
      });
    }

    // CTA button click tracking
    const ctaButton = popup.querySelector('.desight-popup__cta a');
    if (ctaButton) {
      ctaButton.addEventListener('click', function () {
        if (window.dataLayer) {
          window.dataLayer.push({
            'event': 'popup_cta_clicked'
          });
        }
      });
    }

    // Initialize trigger
    initTrigger();
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMarketingPopup);
  } else {
    initMarketingPopup();
  }

  // Export to global scope for external access
  window.DeSightMarketingPopup = {
    init: initMarketingPopup,
    resetCookie: function () {
      CookieManager.delete('desight_popup_shown');
    }
  };

})();

